<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateEngine"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              :farms="farms"
              :energy_sources="energy_sources"
              @on-validated="onFirstStepValidated"
              @fillWizardForm="fillWizardForm('firstStep')"
              @showHideLoading="showHideLoading"
              @changeFarm="changeFarm"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.detailed_info')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              :blocks="blocks"
              :wizardModel="wizardModel"
              @on-validated="onStepValidated"
              @fillWizardForm="fillWizardForm('secondStep')"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>

          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              3. {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('irrigation.engine') }}:</strong>
                        </h6>
                        {{ wizardModel.engine }}
                      </td>
                      <!-- </tr>
                    <tr class="shadow-sm"> -->
                      <td>
                        <h6>
                          <strong>{{ $t('irrigation.design') }}:</strong>
                        </h6>
                        {{ wizardModel.design }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('devices.brand') }}:</strong>
                        </h6>
                        {{ wizardModel.brand }}
                      </td>
                      <!-- </tr>
                    <tr class="shadow-sm"> -->
                      <td>
                        <h6>
                          <strong>{{ $t('irrigation.model') }}:</strong>
                        </h6>
                        {{ wizardModel.model }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.description') }}:</strong>
                        </h6>
                        {{ wizardModel.description }}
                      </td>
                      <!-- </tr>
                    <tr class="shadow-sm"> -->
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.farm') }}:</strong>
                        </h6>
                        {{ farm }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('irrigation.nozzle') }}:</strong>
                        </h6>
                        {{ wizardModel.nozzle }}
                      </td>
                      <!-- </tr>
                    <tr class="shadow-sm"> -->
                      <td>
                        <h6>
                          <strong>{{ $t('irrigation.sprinkling') }}:</strong>
                        </h6>
                        {{ wizardModel.aspersion_ha }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('irrigation.efficiency') }}:</strong>
                        </h6>
                        {{ wizardModel.efficiency }}
                      </td>
                      <!-- </tr>
                    <tr class="shadow-sm"> -->
                      <td>
                        <h6>
                          <strong>{{ $t('irrigation.plate') }}:</strong>
                        </h6>
                        {{ wizardModel.lamina }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('irrigation.real_psi') }}</strong>
                        </h6>
                        {{ wizardModel.psi_real }}
                      </td>
                      <!-- </tr>
                    <tr class="shadow-sm"> -->
                      <td>
                        <h6>
                          <strong>{{
                            $t('irrigation.irrigation_area_ha')
                          }}</strong>
                        </h6>
                        {{ wizardModel.irrigation_area }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{
                            $t('irrigation.irrigation_blocks_number')
                          }}</strong>
                        </h6>
                        {{ wizardModel.irrigation_blocks }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('irrigation.hourmeter') }}</strong>
                        </h6>
                        {{ wizardModel.hourmeter_name }}
                      </td>
                      <!-- </tr>
                    <tr class="shadow-sm"> -->
                      <td>
                        <h6>
                          <strong>{{ $t('irrigation.hydrometer') }}</strong>
                        </h6>
                        {{ wizardModel.hydrometer_name }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import SweetAlert from 'src/class/Alerts';
import FirstStep from './steps/FirstStep.vue';
import SecondStep from './steps/SecondStep.vue';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  components: {
    FirstStep,
    SecondStep,
  },

  computed: {
    farm() {
      let farm = this.farms.filter(
        (farm) => farm.id == this.wizardModel.farm_id
      );
      if (farm.length > 0) {
        return farm[0]['name'];
      }
      return null;
    },
  },

  data() {
    return {
      wizardModel: {},
      farms: [],
      energy_sources: [],
      blocks: [],
      responseAxios: null,
    };
  },

  mixins: [MixinPermissions, MixinForm, mixinMasters, MixinMenu],

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = {};
      this.$refs.secondStep.model = {
        nozzle: null,
        aspersion_ha: null,
        efficiency: null,
        lamina: null,
        psi_real: null,
        irrigation_area: null,
        hourmeter_name: null,
        hydrometer_name: null,
        hydrometer: null,
        hourmeter: null,
        block_ids: [],
        irrigation_blocks: null,
      };
    },

    onStepValidated(_, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    getSelectAll() {
      if (this.responseAxios) {
        this.blocks = this.concatAll(
          this.responseAxios,
          null,
          i18n.t('uti.mixinMasters.selectAll')
        );
      }
    },

    onFirstStepValidated(_, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
      this.showHideLoading(true);
      Axios.getMasters(`block/${this.wizardModel.farm_id}`)
        .then((response) => {
          this.responseAxios = response.data.data;
          this.getSelectAll();
          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    changeFarm() {
      this.$refs.secondStep.model.block_ids = [];
    },

    fillWizardForm(ref) {
      this.wizardModel = Object.assign(
        {},
        this.wizardModel,
        this.$refs[ref].model
      );
    },

    storeUpdateEngine() {
      if (this.wizardModel.hourmeter_name == 'SI') {
        this.wizardModel.hourmeter = 1;
      } else if (this.wizardModel.hourmeter_name == 'NO') {
        this.wizardModel.hourmeter = 0;
      }

      if (this.wizardModel.hydrometer_name == 'SI') {
        this.wizardModel.hydrometer = 1;
      } else if (this.wizardModel.hydrometer_name == 'NO') {
        this.wizardModel.hydrometer = 0;
      }

      this.showHideLoading(true);
      if (sessionStorage.getItem('editForm')) {
        this.wizardModel.route = 'irrigation/engine/edit';
        this.wizardModel.id = JSON.parse(sessionStorage.getItem('editForm')).id;
        this.wizardModel.user_id = store.state.auth.user.id;
        Axios.updateMaster(this.wizardModel)
          .then((response) => {
            this.showHideLoading();
            showContinue(
              this,
              response.data.message ? response.data.message : response.errors,
              '/irrigation/engine',
              'wizardModel'
            );
          })
          .catch((error) => {
            this.showHideLoading();
            SweetAlert.danger(
              error.response.data.message ? error.response.data.message : error
            ).then(() => {
              sessionStorage.removeItem('editForm');
              this.$router.push('/irrigation/engine');
            });
          });
      } else {
        this.wizardModel.route = 'irrigation/engine/create';
        this.wizardModel.user_id = store.state.auth.user.id;
        Axios.saveMaster(this.wizardModel)
          .then((response) => {
            this.showHideLoading();
            showContinue(
              this,
              response.data.message ? response.data.message : response.errors,
              '/irrigation/engine',
              'wizardModel'
            );
          })
          .catch((error) => {
            this.showHideLoading();
            this.showMessageErrors(error);
          });
      }
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('irrigation/energysources'),
      ])
        .then((responses) => {
          this.farms = responses[0].data.data;
          this.energy_sources = responses[1].data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else this.showHideLoading();
  },

  mounted() {
    this.selectedItemOnMenu('irrigation');
  },

  destroyed() {
    this.deselectedItemOnMenu('irrigation');
  },
};
</script>
